import styled from 'styled-components';
import { themeGet } from '../../v2/foundation/theme/themeGet/get.js';
import { pxToRem } from '../../v2/foundation/spacing/utils.js';

var CalendarContainer = styled.div.withConfig({
  displayName: "CalendarContainer",
  componentId: "sc-ro2ptt-0"
})(["display:inline-flex;background-color:", ";border:", " solid ", ";border-radius:", ";box-shadow:", ";&:focus-visible{outline:0;}"], themeGet('colors.gray.0'), pxToRem(1), themeGet('colors.gray.100'), themeGet('borderRadius.md'), themeGet('dropShadow.100'));

export { CalendarContainer };
